'use client';

import { createContext, PropsWithChildren } from 'react';

export type AppName = 'teacherfirst' | 'opsportal';

const AppContext = createContext<{ app: AppName }>({ app: 'teacherfirst' });

export const AppContextProvider = ({ app, children }: PropsWithChildren<{ app: AppName }>) => (
  <AppContext.Provider value={{ app }}>{children}</AppContext.Provider>
);

export default AppContext;
